import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

export const updateRouteExecutionEvents = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  uui.domain.ui.forms.RouteExecutionEventsUpdate,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/route/updateRouteExecutionEvents', async (events, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/route/updateRouteExecutionEvents', {
      category: 'rpc',
      type: 'rpc/route/updateRouteExecutionEvents',
      events,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {updateRouteExecutionEvents}`,
      { tags: ['rpc', 'order'], info: { events } },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Set route with labels failed`,
      error,
    })
  }
})
